module.exports = __webpack_public_path__ + "img/電気回路_4_5_1.72599ee6.png";